import React from 'react';
import InitialAvatar from '../InitialAvatar';
import './PresenceBar.css';

/**
 * Inline badge for a single cell: who else has this cell open, and a lock chip
 * when someone else is holding it. Feed it from usePresence:
 *
 *   <CellPresence users={presence.usersInCell(key)} owner={presence.lockOwner(key)} />
 */
const CellPresence = ({
    users = [],
    owner = null,
    size = 20,
    compact = false,
    /** Completes the tooltip: "<name> is <activity>". */
    activity = 'working here',
}) => {
    if (!users.length && !owner) return null;

    return (
        <span className="presence-cell">
            {users.map((user) => (
                <span
                    key={user.email}
                    className="presence-cell-avatar"
                    // A merged roster (one row showing several kinds of activity at
                    // once) tags each user; otherwise everyone shares `activity`.
                    title={`${user.name} is ${user.activity || activity}`}
                >
                    <InitialAvatar name={user.name || user.email} size={size} useStoredAvatar={false} />
                </span>
            ))}
            {owner && (
                <span className="presence-cell-lock" title={`${owner.name} is editing this`}>
                    <i className="fa fa-lock" aria-hidden="true" />
                    {!compact && <span>{owner.name}</span>}
                </span>
            )}
        </span>
    );
};

/** Banner for the header of a locked dropdown/modal. */
export const CellLockBanner = ({ owner }) => {
    if (!owner) return null;
    return (
        <div className="presence-lock-banner" role="status">
            <i className="fa fa-lock" aria-hidden="true" />
            <span>{owner.name} is editing this — read-only until they finish</span>
        </div>
    );
};

export default CellPresence;
